// values are coming from Zapier via HTTP header 'form-type'
export enum EbpTypeformType {
  MycawInitial = 'MYCAW-initial',
  MycawFollowUp = 'MYCAW-follow-up',
  WorkFocused = 'work-focused',
  Fatigue = 'fatigue',
  RtwSe = 'RTW-SE',
  MdtFeedback = 'MDT-feedback',
}
